import Utilities from '@util/Utilities';
import React from 'react';
import _uniqueId from 'lodash/uniqueId';
import { useFieldContext } from '@app/site/_form';


type CheckBoxFieldProps = {
	label?: string,
	hasError?: boolean,
	isLoading?: boolean,
	disabled?: boolean,
	extraClassName?: string,
	extraLabelClassName?: string,
	maxLength?: number,
	variant?: 'classic' | 'button',
	value: any,
	/** Handle a selection before committing it to the form, for example after a dialog. */
	onChange?: (value: any) => void
}

export const RadioField: React.FunctionComponent<CheckBoxFieldProps> = (props) => {
	const field = useFieldContext<any>();
	const uniqueId = _uniqueId('input-');
	const checked = field.state.value == props.value;

	if (props.variant === 'button') {
		return <div className="flex items-center">
			<input
				id={uniqueId}
				type="radio"
				disabled={props.disabled}
				className="sr-only"
				value={props.value}
				checked={checked}
				onChange={() => props.onChange ? props.onChange(props.value) : field.handleChange(props.value)}
			/>
			<label htmlFor={uniqueId} className={Utilities.classNames(
				"inline-flex min-w-[98px] items-center justify-center rounded-md border px-4 py-2 text-sm font-semibold leading-5 shadow-sm transition-colors",
				checked ? "border-blue-600 bg-blue-600 text-white" : "border-gray-300 bg-white text-gray-900 hover:bg-gray-50",
				props.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
				!!props.extraClassName ? props.extraClassName : "",
				!!props.extraLabelClassName ? props.extraLabelClassName : ""
			)}>
				{props.label}
			</label>
		</div>;
	}

	return <div className="flex items-center">
		<input
			id={uniqueId}
			type="radio"
			disabled={props.disabled}
			className={Utilities.classNames("h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-600 cursor-pointer",
				!!props.extraClassName ? props.extraClassName : "")}
			value={props.value}
			checked={checked}
			onChange={() => props.onChange ? props.onChange(props.value) : field.handleChange(props.value)}
		/>
		<label htmlFor={uniqueId} className={Utilities.classNames('ml-2 block text-sm font-medium leading-6 whitespace-nowrap cursor-pointer', props.disabled ? 'text-gray-400' : 'text-gray-500', !!props.extraLabelClassName ? props.extraLabelClassName : "")}>
			{props.label}
		</label>
	</div>;
};
